import useCalenderFilter from "../../../hooks/useCalenderFilter";
import {
  Box,
  Button,
  List,
  ListItem,
  Menu,
  MenuItem,
  Stack,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import styles from "../../../styles/pages/home.module.scss";
import dayjs from "dayjs";
import assest from "../../../json/assest";
// import { DatePicker } from "@imarabinda/antd";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { getDateApiFormat } from "../../../lib/functions/utils.lib";
import {
  setFrom,
  setTo,
} from "../../../redux-toolkit/slices/submitted.deleted.slice";
import useCalenderFilterTwo from "../../../hooks/useCalenderFilterTwo";

// const { RangePicker } = DatePicker;

import { DatePicker } from "antd";
// import "antd/dist/antd.css";
// import '~antd/dist/antd.css';
import moment from "moment";
import CalenderDate from "../../../pages/Calender";
const { RangePicker } = DatePicker;

export default function SubmittedDeleteFilterTwo({
  hideLastItem,
  hideFilter,
  children,
  hideCalender,
  hideDateRangeFilter,
  rightItems,
  leftItems,
  filterModalProps,
}) {
  const calenderContainerId = "calender-input-filter-row";
  const {
    calenderFilter,
    DateFilterRangeList,
    calenderFilterShowValue,
    changeCalenderFilter,
    calenderOpen,
    resetCalender,
    confirmCalender,
    confirmedCalenderValue,
    calenderValue,
    setCalenderValue,
    toggleCalender,
    closeCalender,
    confirmCalenderTwo,
    dateRangeFilter: {
      dateRangeFilterAnchor,
      openedDateRangeFilter,
      handleOpenDateRangeFilter,
      handleCloseDateRangeFilter,
    },
  } = useCalenderFilter({
    containerId: calenderContainerId,
  });

  // const [openFilterModal, setOpenFilterModal] = useState(false);
  const handleOpenFilterModal = useCallback(() => {
    setOpenFilterModal(true);
  }, []);
  const handleCloseFilterModal = useCallback(() => {
    setOpenFilterModal(false);
  }, []);

  const { openFilterModal, setOpenFilterModal, handleTriggreFetch, data } =
    filterModalProps.p;
  const dispatch = useAppDispatch();

  useEffect(() => {
    // console.warn("calenderValue", calenderValue);
    if (calenderValue) {
      if (calenderValue[0]) {
        dispatch(setFrom(getDateApiFormat(calenderValue[0]["$d"])));
      }
      if (calenderValue[1]) {
        dispatch(setTo(getDateApiFormat(calenderValue[1]["$d"])));
      }
      handleTriggreFetch();
    }
  }, [calenderValue]);

  return (
    <>
      {!hideDateRangeFilter ? (
        <Box className={styles.table_left2}>
          {leftItems}
          <Box className="commonSearchBar_modal">
            <p>
              Showing videos for{" "}
              {calenderFilter ? (
                <>
                  <Box
                    className={`dayList ${
                      openedDateRangeFilter ? "date-black" : "date-blue"
                    }`}
                  >
                    <Button
                      aria-haspopup="true"
                      onClick={handleOpenDateRangeFilter}
                    >
                      {calenderFilter?.name}
                    </Button>
                    <Menu
                      anchorEl={dateRangeFilterAnchor}
                      open={openedDateRangeFilter}
                      onClose={handleCloseDateRangeFilter}
                      className="dateList"
                    >
                      {DateFilterRangeList.map((filter) => {
                        if (filter != calenderFilter) {
                          return (
                            <MenuItem
                              onClick={changeCalenderFilter(filter)}
                              key={filter.name}
                              selected={filter === calenderFilter}
                            >
                              {filter.name}
                            </MenuItem>
                          );
                        }
                      })}
                    </Menu>
                  </Box>
                  <span className="dateList">({calenderFilterShowValue})</span>
                </>
              ) : (
                <>
                  the period from{" "}
                  {confirmedCalenderValue?.[0] ? (
                    <span className="dayList">
                      {dayjs(confirmedCalenderValue?.[0]).format("LL")}
                    </span>
                  ) : null}{" "}
                  to{" "}
                  {calenderValue?.[1] ? (
                    <span className="dayList">
                      {dayjs(confirmedCalenderValue?.[1]).format("LL")}
                    </span>
                  ) : null}
                </>
              )}
            </p>
            {calenderFilter?.name !== "All time" ? (
              <span className="reset_picker" onClick={resetCalender}>
                <svg
                  width="11"
                  height="11"
                  viewBox="0 0 11 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.5 10C7.975 10 10 7.975 10 5.5C10 3.025 7.975 1 5.5 1C3.025 1 1 3.025 1 5.5C1 7.975 3.025 10 5.5 10Z"
                    stroke="currentColor"
                    strokeLinecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M4.22705 6.7832L6.77263 4.23762"
                    stroke="currentColor"
                    strokeWidth="0.8"
                    strokeLinecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M6.77263 6.76238L4.22705 4.2168"
                    stroke="currentColor"
                    strokeWidth="0.8"
                    strokeLinecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
                reset
              </span>
            ) : null}
          </Box>
        </Box>
      ) : null}

      <Box className={styles.table_right}>
        <List>
          <CalenderDate confirmCalender={confirmCalenderTwo} />
          {!hideLastItem ? (
            <ListItem className={styles.table_video_button}>
              <Button>
                All videos: <span>{data?.total}</span>
              </Button>
            </ListItem>
          ) : null}
        </List>
        {rightItems}
      </Box>
      {children}
    </>
  );
}
